const infoText = {
  epc: 'Epc is calculated as (tracker revenue)/(traffic source clicks)',
  ts_epc: 'Traffic Source Epc is calculated as (traffic source revenue)/(traffic source clicks). Use only if you are posting revenues to the traffic source.',
  epi: 'Epi is calculated as (tracker revenue)/(traffic source impressions).',
  tr_epc: 'Tracker Epc is calculated as (tracker revenue)/(tracker clicks)',
};

const generateBidOptions = (device = '') => [
  { value: 'set', text: `Set ${device} Bid To` },
  { value: 'increase', text: `Increase ${device} Bid By` },
  { value: 'decrease', text: `Decrease ${device} Bid By` },
];

const bidActionOptions = generateBidOptions();

const bidUnitOptions = [
  { value: 'static', text: '$' },
  { value: 'percentage', text: '%' },
];

const bidToOptions = [
  { value: 'bid', text: 'of Current Bid' },
  // { value: 'epc', text: 'of EPC' },
  { value: 'ts_epc', text: 'of Traffic Source EPC' },
  { value: 'epi', text: 'of EPI' },
  { value: 'tr_epc', text: 'of Tracker EPC' },
  { value: 'coefficient', text: 'of Current Coefficient' },
  { value: 'cpm', text: 'of Current CPM' },
  { value: 'ts_epm', text: 'of Traffic Source EPM' },
  { value: 'tr_epm', text: 'of Tracker EPM' },
];

const bidModelTemplates = {
  classic: {
    action: {
      set: {
        unit: {
          static: {},
          percentage: {
            to: {
              // 'epc': { info: infoText.epc },
              ts_epc: { info: infoText.ts_epc },
              epi: { info: infoText.epi },
              tr_epc: { info: infoText.tr_epc },
            },
          },
        },
      },
      increase: {
        unit: {
          static: {},
          percentage: {
            to: {
              bid: {},
              // 'epc': { info: infoText.epc },
              ts_epc: { info: infoText.ts_epc },
              epi: { info: infoText.epi },
              tr_epc: { info: infoText.tr_epc },
            },
          },
        },
      },
      decrease: {
        unit: {
          static: {},
          percentage: {
            to: {
              bid: {},
              // 'epc': { info: infoText.epc },
              ts_epc: { info: infoText.ts_epc },
              epi: { info: infoText.epi },
              tr_epc: { info: infoText.tr_epc },
            },
          },
        },
      },
    },
  },
  cpm: {
    action: {
      set: {
        unit: {
          static: {},
          percentage: {
            to: {
              // 'epc': { info: infoText.epc },
              ts_epm: { info: infoText.ts_epm },
              tr_epm: { info: infoText.tr_epm },
            },
          },
        },
      },
      increase: {
        unit: {
          static: {},
          percentage: {
            to: {
              cpm: {},
              // 'epc': { info: infoText.epc },
              ts_epm: { info: infoText.ts_epm },
              tr_epm: { info: infoText.tr_epm },
            },
          },
        },
      },
      decrease: {
        unit: {
          static: {},
          percentage: {
            to: {
              cpm: {},
              // 'epc': { info: infoText.epc },
              ts_epm: { info: infoText.ts_epm },
              tr_epm: { info: infoText.tr_epm },
            },
          },
        },
      },
    },
  },
};

module.exports = {
  bidActionOptions, bidUnitOptions, bidToOptions, bidModelTemplates, generateBidOptions,
};
